import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { finalize, Observable } from 'rxjs';

import { Help } from '@shared/models';

import { BaseService } from '../base.service';
import { LoadersService } from '../loaders.service';

@Injectable({
  providedIn: 'root',
})
export class HelpService extends BaseService {
  constructor(
    private http: HttpClient,
    private loadersService: LoadersService
  ) {
    super();
  }

  getByKey(key: string, loader: string): Observable<Help> {
    this.loadersService.show(loader);
    return this.http.get<Help>(`${this.baseUrl}/helps/${key}`).pipe(finalize(() => this.loadersService.hide(loader)));
  }

  update(dto: Help, loader: string): Observable<Help> {
    this.loadersService.show(loader);
    return this.http.put<Help>(`${this.baseUrl}/helps`, dto).pipe(finalize(() => this.loadersService.hide(loader)));
  }
}
